module.exports = __webpack_public_path__ + "img/ETC-alt.7123e46f.svg";